import { ExtendedAttributeFilterType } from '../enums/extended-attribute-filter-value-type.enum';
import { IExtendedAttributeFilterQuery } from '../interfaces/extended-attribute-filter-values.query.interface';
import { ExtendedAttributeFilterValue } from './extended-attribute-filter-value';

export class ExtendedAttributeFilter {
    extendedAttributeId: string;
    name: string;
    max: string;
    min: string;
    translationKey: string;
    type: ExtendedAttributeFilterType;
    values: { value: string; translationKey: string }[];

    constructor(query: IExtendedAttributeFilterQuery) {
        this.extendedAttributeId = query.extended_attribute_id.toString();
        this.name = query.name;
        this.max = query.max;
        this.min = query.min;
        this.type = query.type;
        this.values = query.values?.length ? query.values.map((value) => new ExtendedAttributeFilterValue(value)) : [];
        this.translationKey = query.translation_key;
    }
}
